import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import LinkButton from 'components/LinkButton'
import { CONTACT_ROUTE } from 'routes/constants'
import { sectionData } from './constants'

const Hero = ({
  heading,
  subheading,
  buttonText,
  isCentered,
  isSubHeadingBelow,
}) => (
  <header className="sem__hero-two">
    {!isSubHeadingBelow && (
      <p
        className={cx('sem__hero-two-subheading', {
          '--centered': isCentered,
        })}
      >
        {subheading}
      </p>
    )}
    <h1
      className={cx('sem__hero-two-heading', {
        '--centered': isCentered,
      })}
    >
      {heading}
    </h1>
    {isSubHeadingBelow && (
      <p
        className={cx('sem__hero-two-subheading', {
          '--centered': isCentered,
          '--subheading-below': isSubHeadingBelow,
        })}
      >
        {subheading}
      </p>
    )}
    <div
      className={cx('sem__hero-two-button', {
        '--centered': isCentered,
      })}
    >
      <LinkButton text={buttonText} route={CONTACT_ROUTE} />
    </div>
  </header>
)

Hero.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  buttonText: PropTypes.string,
  isSubHeadingBelow: PropTypes.bool,
  isCentered: PropTypes.bool,
}

Hero.defaultProps = sectionData

export default Hero
